export var MediaTransformationRatio = /*#__PURE__*/function (MediaTransformationRatio) {
  MediaTransformationRatio[MediaTransformationRatio["ratio4to3"] = 1.3333333333333333] = "ratio4to3";
  MediaTransformationRatio[MediaTransformationRatio["ratio16to9"] = 1.7777777777777777] = "ratio16to9";
  return MediaTransformationRatio;
}(MediaTransformationRatio || {});
export var MediaTransformationQuality = /*#__PURE__*/function (MediaTransformationQuality) {
  MediaTransformationQuality["best"] = "best";
  MediaTransformationQuality["good"] = "good";
  MediaTransformationQuality["eco"] = "eco";
  MediaTransformationQuality["low"] = "low";
  return MediaTransformationQuality;
}(MediaTransformationQuality || {});
// for use as fallback in case provider cannot handle named qualities
export function mediaTransformationQualityNameToNumber(v) {
  if (v === MediaTransformationQuality.best) return 95;
  if (v === MediaTransformationQuality.good) return 75;
  if (v === MediaTransformationQuality.eco) return 50;
  if (v === MediaTransformationQuality.low) return 25;
}